import { render, staticRenderFns } from "./DetailMerkBarang.vue?vue&type=template&id=467b284d&"
import script from "./DetailMerkBarang.vue?vue&type=script&lang=js&"
export * from "./DetailMerkBarang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports